import { Controller } from '@hotwired/stimulus'

const DONE_DURATION_MS = 2_000

/**
 * @description Swaps a copy button's icon to a done state for a moment after the surrounding
 * stimulus-library clipboard controller reports a successful copy (`clipboard:copied`).
 *
 * The event bubbles from the clipboard controller's element, so the button listens at the window
 * and only reacts when that element contains it: other copy buttons on the page stay idle.
 */
export default class CopyButtonController extends Controller {
  static targets = ['idle', 'done']

  disconnect() {
    clearTimeout(this.timer)
  }

  confirm(event) {
    if (!event.target.contains(this.element)) return

    this.showDone(true)
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.showDone(false), DONE_DURATION_MS)
  }

  showDone(done) {
    this.idleTarget.hidden = done
    this.doneTarget.hidden = !done
  }
}
